import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectCreateArgs } from "types/generated";

import { INTENT_PROJECT_BASIC_FRAGMENT } from "../gql";

export const CREATE_INTENT_PROJECT: TypedDocumentNode<
  { intentProjectCreate: IntentProject },
  MutationIntentProjectCreateArgs
> = gql`
  mutation CreateIntentProject(
    $name: String!
    $description: String
    $space: ID!
    $labels: [String!]
    $workerPool: ID
    $runnerImage: String
  ) {
    intentProjectCreate(
      name: $name
      description: $description
      space: $space
      labels: $labels
      workerPool: $workerPool
      runnerImage: $runnerImage
    ) {
      ...IntentProjectBasic
    }
  }
  ${INTENT_PROJECT_BASIC_FRAGMENT}
`;
